$(document).ready(function(){

    mapInit([54.718005, 55.954909], [54.718005, 55.954909], 'contact-map'); //RECardDescription-Map

});